import React from 'react';
import { styled } from '@mui/material/styles';
import {
    Box,
    TextField,
} from '@mui/material';


const ValidationTextField = styled(TextField)({
    // Label colors
    '& label': {
        color: 'rgba(178, 235, 177, 1)',
    },
    '& label.Mui-disabled': {
        color: 'rgba(139, 180, 146, 1)',
    },
    '& label.Mui-focused': {
        color: 'rgba(178, 235, 177, 1)',
    },
    '& label.Mui-error': {
        color: 'rgba(255, 105, 97, 1)',
    },
    // Base outline (applies to both input & multiline textarea)
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(139, 142, 146, 1)',
        borderWidth: 1,
    },
    // Text color for both single-line and multiline
    '& .MuiOutlinedInput-input, & .MuiOutlinedInput-inputMultiline': {
        color: 'white',
    },
    // Placeholder color consistency
    '& .MuiOutlinedInput-input::placeholder, & .MuiOutlinedInput-inputMultiline::placeholder': {
        color: 'rgba(255,255,255,0.6)',
        opacity: 1,
    },
    // Hover (not focused/error/disabled)
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.7)',
        borderWidth: 2,
    },
    // Focused state
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(178, 235, 177, 1)',
        borderWidth: 2,
    },
    // Error state
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 105, 97, 1)',
        borderWidth: 2,
    },
    // Disabled state
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(139, 142, 146, 1)',
        borderWidth: 1,
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-input': {
        backgroundColor: 'rgba(255,255,255, 0.3)',
        borderRadius: 4,
        WebkitTextFillColor: 'rgba(255,255,255,0.7)',
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-inputMultiline': {
        backgroundColor: 'rgba(255,255,255, 0.3)',
        borderRadius: 4,
        WebkitTextFillColor: 'rgba(255,255,255,0.7)',
    },
})


export default function SimpleTextField(props) {
    const {
        label,
        onChange,
        value,
        disabled,
        required = false,
        error = false,
        helperText = '',
        width = '250px',
        multiline = false,
        rows,
        size = 'medium',
        placeholder,
        sx,
        ...rest
    } = props;

    return (
        <React.Fragment>
            <Box
                display="flex"
                alignContent="flex-start"
                flexDirection="column"
                flexWrap="wrap"
                width="auto"
            >
                <Box width={width}>
                    <ValidationTextField
                        label={label}
                        onChange={(event) => onChange(event, label)}
                        sx={sx}
                        variant="outlined"
                        value={value}
                        disabled={disabled || false}
                        required={required}
                        error={error}
                        helperText={helperText}
                        fullWidth
                        multiline={multiline}
                        rows={rows}
                        size={size}
                        placeholder={placeholder}
                        {...rest}
                    />
                </Box>
            </Box>
        </React.Fragment>
    );
}
